import React from "react";
import classes from "./DashboardTokensCardStyles.module.scss";
import { uniqueId } from "lodash";
import AssetDropdown from "../../pages/Dashboard/AssetDropdown";
import { useWeb3React } from "@web3-react/core";

type StatsType = {
  title: string;
  content: string;
};

type Props = {
  icon: string;
  title: string;
  price: string;
  marketCap: string;
  fdv: string;
  statsContent: StatsType[];
  graph: JSX.Element;
};

export const DashboardTokensCard = ({ title, marketCap, fdv, price, icon, statsContent, graph }: Props) => {
  const { active } = useWeb3React();
  return (
    <div className={classes.cardWrapper}>
      <div className={classes.headerWrapper}>
        <div className={classes.leftWrapper}>
          <img width={36} height={36} src={icon} alt="" />
          <span className={classes.cardTitle}>{title}</span>
          {active && <AssetDropdown assetSymbol={title} />}
        </div>
        {price && (
          <div className={classes.headerItemWrapper}>
            <span className={classes.headerItemTitle}>Price:</span>
            <span className={classes.headerItemContent}>${price}</span>
          </div>
        )}
        {marketCap && (
          <div className={classes.headerItemWrapper}>
            <span className={classes.headerItemTitle}>Market cap:</span>
            <span className={classes.headerItemContent}>${marketCap}</span>
          </div>
        )}
        {fdv && (
          <div className={classes.headerItemWrapper}>
            <span className={classes.headerItemTitle}>FDV:</span>
            <span className={classes.headerItemContent}>${fdv}</span>
          </div>
        )}
      </div>
      <div className={classes.contentWrapper}>
        <div className={classes.statsWrapper}>
          {statsContent.map((statsItem) => (
            <div key={uniqueId(statsItem.title)} className={classes.statsItemWrapper}>
              <span className={classes.statsItemTitle}>{statsItem.title}</span>
              <span className={classes.statsItemContent}>{statsItem.content}</span>
            </div>
          ))}
        </div>
        <div className={classes.graphWrapper}>{graph}</div>
      </div>
    </div>
  );
};
